import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getStoreValue } from "../../utils/store";

const PrivateRoutes = () => {
  const location = useLocation();
  const token = getStoreValue("token");
  const decodedToken = token && window.atob(token);
  return !decodedToken ? (
    location.pathname === "/users/list" ? (
      <Navigate replace to="/users/login" />
    ) : (
      <Navigate replace to="/" />
    )
  ) : (
    <Outlet />
  );
};

export default PrivateRoutes;
